/* eslint-disable max-len */
// @flow
import React from 'react';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { Section } from '@finect/tabular-components/Section';
import { ReviewCute } from '@finect/tabular-components/Reviews';
import { SectionTitle } from '../Titles';
import { Container, TopAnswers } from './partials';

type Props = {
  staticContext?: Object
};

type State = {
  reviews: Object
};

export class MainProductsReviews extends React.Component<Props, State> {
  state =
    typeof window === 'undefined'
      ? { reviews: this.props.staticContext?.initialData.mainProductsReviews.reviews || {} }
      : { reviews: window.initialData?.mainProductsReviews.reviews || {} };

  async componentDidMount() {
    if (!this.state.reviews.items || !this.state.reviews.items.length) {
      const data = await MainProductsReviews.loadInitialData();

      this.setState({ reviews: data.reviews || {} });
    }
  }

  static loadInitialData(cookie?: string) {
    return Promise.resolve(
      finectAPI({
        version: 'v4',
        path: 'contents/reviews/latest?filter=adviser+eq+true+and+score+eq+4+or+score+eq+5',
        credentials: cookie,
        method: 'GET',
        onSuccess: ({ data }: { data: Object }) => data,
        onError: (err) => console.log(err, 'Request to reviews/advisers failed!'), // eslint-disable-line
      })
    ).then(reviews => ({ reviews }));
  }

  render() {
    const { reviews } = this.state;

    const reviewsMap =
      reviews?.reviews
        ?.map((review) => {
          const author = reviews?.authors?.find(item => item.id === review.author);
          return {
            author: {
              ...author,
              image: author.icon,
              organizations: author.organizations.map(item => ({ ...item, image: item.logo }))
            },
            isHighlighted: author.isHighlighted,
            product: {
              subtype: review.product.subtype,
              entity: { ...review.product, displayName: review.product.name }
            },
            date: review.revision.updated ? review.revision.updated : review.revision.created,
            id: review.id,
            score: review.score,
            title: review.title,
            body: review.body
          };
        })
        .sort((itemA, itemB) => {
          if (itemA.isHighlighted && !itemB.isHighlighted) return -1;
          if (!itemA.isHighlighted && itemB.isHighlighted) return 1;
          return 0;
        }) || [];

    return (
      <Container>
        <SectionTitle title="Reviews de productos de inversión" noMargin />
        <Section>
          <TopAnswers>
            {reviewsMap?.map((review, index) => (
              <ReviewCute key={index} finectApp="front-advisers" review={review} lazyLoad />
            ))}
          </TopAnswers>
        </Section>
      </Container>
    );
  }
}
